/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2023-10-24 15:11:33
 */
/* eslint-disable */
import React, { useState, useEffect, ChangeEvent } from 'react'
import { useAppSelector, useAppDispatch } from '../../app/hooks'
import { Button, Form, Input, Select, TreeSelect } from 'antd'
import classnames from 'classnames'
import todaycam_logo from '../../images/todaycam_logo.png'
import { calcCharactersLength } from '../../utils/utils'
import sensors from '../../utils/sensors'
import { fetchIndustryList } from '../../actions/main'

interface IndustryItem {
  code: string
  name: string
  children?: IndustryItem[]
}

interface SetGroupPanelProps {
  onSubmit: (data: {
    groupName: string
    industryType: string | undefined
    industryName: string
  }) => void
}

const generateTreeData = (
  data: IndustryItem[]
): {
  title: string
  value: string
  key: string
  children: ReturnType<typeof generateTreeData>
}[] => {
  return data.map(({ code, name, children = [] }) => ({
    title: name,
    value: code,
    key: code,
    children: generateTreeData(children)
  }))
}

function SetGroupPanel(props: SetGroupPanelProps) {
  const { onSubmit } = props
  const dispatch = useAppDispatch()
  const isDesktop = useAppSelector((state) => state.main.isDesktop)

  type ValidateStatus = '' | 'success' | 'warning' | 'error' | 'validating'
  const [groupName, setGroupName] = useState('')
  const [validateStatus, setValidateStatus] = useState<ValidateStatus>('')
  const [groupNameHelp, setGroupNameHelp] = useState('')
  const [industryType, setIndustryType] = useState<string | undefined>(
    undefined
  )
  const [industryName, setIndustryName] = useState('')
  const [industryList, setIndustryList] = useState<IndustryItem[]>([])

  useEffect(() => {
    dispatch(fetchIndustryList()).then((res) => {
      setIndustryList(res.industry_types)
    })
  }, [dispatch])

  const handleGroupNameChange = (e: ChangeEvent<HTMLInputElement>) => {
    setGroupName(e.target.value)
    if (!calcCharactersLength(e.target.value, 32)) {
      setValidateStatus('error')
      setGroupNameHelp('团队名称最多可输入16个汉字')
    } else {
      setValidateStatus('')
      setGroupNameHelp('')
    }
  }

  const handleSubmit = () => {
    onSubmit({
      groupName,
      industryType,
      industryName
    })
  }

  const treeData = generateTreeData(industryList)

  return (
    <div
      className={classnames('panel', {
        animated: !isDesktop,
        zoomIn: !isDesktop
      })}
      key="login-panel"
    >
      <img className="logo" src={todaycam_logo} alt="今日水印相机" />
      <h3 className="title" id="title">
        完善团队信息
      </h3>

      <Form className="login-form">
        <Form.Item validateStatus={validateStatus} help={groupNameHelp}>
          <Input
            size="large"
            placeholder="请输入团队名称"
            value={groupName}
            onChange={handleGroupNameChange}
          />
        </Form.Item>

        <Form.Item>
          <TreeSelect
            treeData={treeData}
            value={industryType}
            onChange={(value: string, label: React.ReactNode[]) => {
              setIndustryType(value)
              setIndustryName(String(label[0] || ''))
            }}
            placeholder="请选择行业"
            dropdownStyle={{
              height: 180
            }}
          />
        </Form.Item>

        <Form.Item>
          <Button
            className="login-button"
            style={{ marginTop: '80px' }}
            type="primary"
            disabled={!!validateStatus || !groupName || !industryType}
            onClick={handleSubmit}
          >
            进入团队
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}

export default SetGroupPanel
